import { createShallowStore, createStore } from '@frontend/store';
import { InsuranceReportTableColumnKeysType } from '../components/InsuranceTables/insurance-reports-table-columns.helper';
import { TablesDataType } from '../types/types';

export type InsuranceReportTableColumnType = InsuranceReportTableColumnKeysType & {
  isChecked: boolean;
};

type ColumnsFilters = {
  [key in keyof TablesDataType]: InsuranceReportTableColumnType[];
};

export interface TableFilterColumnsContextState {
  columnsFilters: ColumnsFilters;
  setColumnsFilters: (tableId: keyof TablesDataType, columns: InsuranceReportTableColumnType[]) => void;
  getColumnsFilters: (tableId: keyof TablesDataType) => InsuranceReportTableColumnType[];

  resetColumnsFilters: () => void;
}

export const useInsuranceReportTableFiltersColumns = createStore<TableFilterColumnsContextState>(
  (set, get) => ({
    columnsFilters: {} as ColumnsFilters,
    setColumnsFilters: (tableId, columns) => {
      set((state) => ({
        columnsFilters: {
          ...state.columnsFilters,
          [tableId]: columns,
        },
      }));
    },
    getColumnsFilters: (tableId) => {
      return get().columnsFilters[tableId] || [];
    },

    resetColumnsFilters: () => {
      set({ columnsFilters: {} as ColumnsFilters });
    },
  }),
  {
    name: 'insuranceReportTableFiltersColumns',
  }
);

export const useInsuranceTableFiltersColumnsShallowStore = createShallowStore<TableFilterColumnsContextState>(
  useInsuranceReportTableFiltersColumns
);
